module.exports = __webpack_public_path__ + "img/couples-078.97a5f420.jpg";